// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/sigwx-cb-and-cloud-depiction.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/sigwx-cb-and-cloud-depiction/sigwx-cb-and-cloud-depiction.js';

mount([g0]);
